export const ceoProfile = {
  name: "Deepak Keshari",
  role: "Founder & CEO at Tedekstra",
  tagline: "Building scalable technology solutions, cultivating high-impact engineering teams, and driving digital transformation.",
  bio: "A technologist by both passion and profession, Deepak believes that technology offers limitless opportunities. He is convinced that, as humans, we are far better equipped to improve the world with it than without it.",
  image: "/images/deepak.png",
  linkedinUrl: "https://www.linkedin.com/in/keshari?utm_source=share_via&utm_content=profile&utm_medium=member_android",
  location: "United Kingdom & Global",
  headline: "Empowering visionary engineering teams and crafting purpose-driven tech products."
};

export const ceoPosts = [
  {
    id: 1,
    title: "A Heartfelt Message to Kick Off the Year: Innovation, Kindness & Connection",
    excerpt:
      "Reflecting on our journey, the milestones achieved, and the power of team collaboration. As we continue to scale, our core mission remains rooted in building cutting-edge digital solutions while nurturing a culture of empathy, continuous learning, and shared success.",
    date: "Jan 2025",
    readTime: "2 min read",
    image: "/images/teampic.png",
    postUrl: "https://www.linkedin.com/in/keshari?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    tags: ["#Leadership", "#TedekstraCulture", "#Innovation", "#Inspiration"],
    likes: 184,
    comments: 38,
    featured: true,
  },
  {
    id: 2,
    title: "Why Inclusive Culture and People-First Leadership Win in Tech",
    excerpt:
      "At Tedekstra, maintaining a 50:50 gender ratio and an environment where every voice is heard isn't just a metric—it's how the best engineering breakthroughs happen. When we empower our people, innovation follows naturally.",
    date: "Feb 2025",
    readTime: "3 min read",
    image: "/images/career-group.png",
    postUrl: "https://www.linkedin.com/in/keshari?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    tags: ["#DiversityInTech", "#Leadership", "#WorkTribe", "#FutureOfWork"],
    likes: 142,
    comments: 29,
    featured: false,
  },
  {
    id: 3,
    title: "The Shift in IT Staff Augmentation & Bespoke Product Engineering",
    excerpt:
      "Modern enterprises don't just need more developers—they need seamless cross-functional partners who understand domain nuances, agile velocity, and high code quality from day one.",
    date: "Nov 2024",
    readTime: "3 min read",
    image: "/images/bespoke.png",
    postUrl: "https://www.linkedin.com/in/keshari?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    tags: ["#SoftwareEngineering", "#AgileTeams", "#DigitalTransformation", "#BespokeTech"],
    likes: 215,
    comments: 44,
    featured: false,
  },
  {
    id: 4,
    title: "Fostering the Next Generation of Tech Talent: Hackathons & Growth Mindset",
    excerpt:
      "Incredible energy witnessing young innovators solve real-world problems. Mentoring emerging developers and building opportunities for fresh talent is one of the most rewarding parts of leading Tedekstra.",
    date: "Aug 2024",
    readTime: "2 min read",
    image: "/images/benefitofaugmentation.jpeg",
    postUrl: "https://www.linkedin.com/in/keshari?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    tags: ["#Hackathon", "#StudentTalent", "#Mentorship", "#TechLeadership"],
    likes: 167,
    comments: 26,
    featured: false,
  }
];
